for (const el of document.querySelectorAll('.vp-block-cas-client')) {
    const taxonomy = 'secteur'
    const select = el.querySelector(`select[name=${taxonomy}]`)
    const url = document
        .querySelector('link[rel="canonical"]')
        ?.getAttribute('href')

    select.addEventListener('input', () => {
        const value = parseInt(select.value, 10) > 0 ? select.value : false
        document.location.href = value
            ? `${url}?${taxonomy}=${value}`
            : `${url}`
    })
}
